import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { CategoryDataTable } from "../default/variables/columnsData";
import CategoryTable from "views/admin/default/components/CategoryTable";
import { getAllCategory } from "proxyUrl";
import axios from "axios";
import { useSelector } from 'react-redux';
export default function User() {

  const [category, setCategory] = useState("");
  const [currentUserRole, setCurrentUserRole] = useState();
  const CurrentUserDetails = useSelector(state => state.user);
  const fetchData = () => {
    axios
      .get(
        getAllCategory,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        return res;
      })
      .then((categorydata) => {
        const categoryData = categorydata.data;
        setCategory(categoryData.data);
      });
  };
  useEffect(() => {
    fetchData();
    if (CurrentUserDetails) {
      setCurrentUserRole(CurrentUserDetails.user.userRole.name)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div className=" add-booking-header  relative overflow-hidden  mx-4 mt-6 flex justify-between rounded-2xl bg-primaryBlue p-3 py-3 shadow-lg dark:bg-navy-800">
      {/* <div className="w-1 h-full bg-primaryBlue absolute top-0 left-0 "></div> */}
      {/* <div className="w-1 h-full bg-primaryBlue absolute top-0 right-0 "></div> */}
        <div className="text-xl font-bold text-white dark:text-white">
          All Categories
        </div>
        <Link to={`/admin/category/add`}>
          <button className="rounded-full bg-white p-1  px-3 text-navy-900 dark:bg-navy-900 dark:text-white">
            Add Category
          </button>
        </Link>
      </div>
      <div className="relative -mt-7  grid w-full grid-cols-1 gap-5 md:grid-cols-1">
        {category ? (
          <CategoryTable
            columnsData={CategoryDataTable}
            editRoute={`/admin/category/edit`}
            deleteRoute={`/admin/category/delete`}
            columnLenghth={category.length}
            tableData={category}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
